import React, { useEffect, useState } from 'react';
import api from '../../api/api';
import { VenueStats } from '../../types';

const thStyle: React.CSSProperties = { padding: '8px', textAlign: 'left', background: 'var(--crm-surface-alt)', color: 'var(--crm-text)', borderBottom: '2px solid var(--crm-border)' };
const tdStyle: React.CSSProperties = { padding: '6px 8px', borderBottom: '1px solid var(--crm-table-row-border)' };
const btn: React.CSSProperties = { padding: '8px 16px', border: '1px solid var(--crm-info)', borderRadius: 'var(--crm-radius-sm)', cursor: 'pointer', color: 'var(--crm-info)', background: 'var(--crm-info-bg)' };

const cardStyle: React.CSSProperties = {
  background: 'var(--crm-surface)',
  color: 'var(--crm-text)',
  border: '1px solid var(--crm-border)',
  boxShadow: 'var(--crm-shadow-sm)',
  borderRadius: 'var(--crm-radius-sm)',
  padding: '16px',
  minWidth: '220px',
  flex: '1 1 220px',
};

const formatMoney = (n: number) => n.toLocaleString('uk-UA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const VenueAnalyticsPage: React.FC = () => {
  const [stats, setStats] = useState<VenueStats[]>([]);
  const [loading, setLoading] = useState(false);
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const params: Record<string, string> = {};
      if (from) params.from = from;
      if (to) params.to = to;
      const res = await api.get<VenueStats[]>('/eventvenues/stats', { params });
      setStats(res.data);
    } catch (error) {
      console.error('VenueAnalyticsPage.load failed', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="page-shell page-shell--wide" style={{ maxWidth: '1400px', margin: '0 auto' }}>
      <h2 style={{ color: 'var(--crm-text)', borderBottom: '2px solid var(--crm-info)', paddingBottom: '8px' }}>Аналітика місць проведення</h2>

      <div className="venue-analytics-filters" style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', alignItems: 'flex-end', margin: '16px 0' }}>
        <label>Дата з:
          <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} style={{ display: 'block', padding: '6px' }} />
        </label>
        <label>Дата по:
          <input type="date" value={to} onChange={(e) => setTo(e.target.value)} style={{ display: 'block', padding: '6px' }} />
        </label>
        <button onClick={load} style={btn}>Застосувати</button>
      </div>

      {loading && <p>Завантаження...</p>}

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginBottom: '24px' }}>
        {stats.map((v) => (
          <div key={v.venueName} style={cardStyle}>
            <h3 style={{ margin: '0 0 8px 0', color: 'var(--crm-text)' }}>{v.venueName || 'Без назви'}</h3>
            <p style={{ margin: '4px 0' }}>Подій: <strong>{v.totalEvents}</strong> (завершено {v.completedEvents}, в очікуванні {v.pendingEvents})</p>
            <p style={{ margin: '4px 0' }}>Дохід: <strong>{formatMoney(v.totalRevenue)} ₴</strong></p>
            <p style={{ margin: '4px 0' }}>Середня к-ть гостей: <strong>{v.avgGuestCount.toFixed(1)}</strong></p>
            <p style={{ margin: '4px 0' }}>Середній дохід: <strong>{formatMoney(v.avgRevenue)} ₴</strong></p>
          </div>
        ))}
        {stats.length === 0 && !loading && (
          <p style={{ color: 'var(--crm-text-muted)' }}>Дані відсутні за обраний період.</p>
        )}
      </div>

      <div style={{ background: 'var(--crm-surface)', border: '1px solid var(--crm-border)', boxShadow: 'var(--crm-shadow-sm)', overflowX: 'auto' }}>
        <table className="crm-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={thStyle}>Місце проведення</th>
              <th style={{ ...thStyle, textAlign: 'right' }}>Всього подій</th>
              <th style={{ ...thStyle, textAlign: 'right' }}>Завершено</th>
              <th style={{ ...thStyle, textAlign: 'right' }}>В очікуванні</th>
              <th style={{ ...thStyle, textAlign: 'right' }}>Дохід</th>
              <th style={{ ...thStyle, textAlign: 'right' }}>Сер. гостей</th>
              <th style={{ ...thStyle, textAlign: 'right' }}>Сер. дохід</th>
            </tr>
          </thead>
          <tbody>
            {stats.map((v) => (
              <tr key={v.venueName}>
                <td style={tdStyle}>{v.venueName || 'Без назви'}</td>
                <td style={{ ...tdStyle, textAlign: 'right' }}>{v.totalEvents}</td>
                <td style={{ ...tdStyle, textAlign: 'right' }}>{v.completedEvents}</td>
                <td style={{ ...tdStyle, textAlign: 'right' }}>{v.pendingEvents}</td>
                <td style={{ ...tdStyle, textAlign: 'right' }}>{formatMoney(v.totalRevenue)} ₴</td>
                <td style={{ ...tdStyle, textAlign: 'right' }}>{v.avgGuestCount.toFixed(1)}</td>
                <td style={{ ...tdStyle, textAlign: 'right' }}>{formatMoney(v.avgRevenue)} ₴</td>
              </tr>
            ))}
            {stats.length === 0 && (
              <tr><td colSpan={7} style={{ padding: '16px', textAlign: 'center', color: 'var(--crm-text-muted)' }}>Немає даних</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VenueAnalyticsPage;
